import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import classNames from "classnames";
import PageNavInner from "./PageNavInner";
import Anchor from "./components/Anchor";
import Item from "./components/Item";

var PageNav = function PageNav(_ref) {
  var sticky = _ref.sticky,
      props = _objectWithoutProperties(_ref, ["sticky"]);

  var getClassName = getClassNameFactory("PageNav");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({
        sticky: sticky
      })
    })
  }, /*#__PURE__*/React.createElement(PageNavInner, _extends({}, props, {
    sticky: sticky
  })));
};

PageNav.displayName = "PageNav";
PageNav.defaultProps = {
  shareLabel: "Share",
  sticky: true,
  spy: true
};
PageNav.Anchor = Anchor;
PageNav.Item = Item;
export default PageNav;